import http from "../http-common";

class FeedbackService {
  getAll() {
    return http.get("/feedbacks");
  }

  getUserFeedbacks(userID) {
    return http.get(`/feedbacks?userid=${userID}`);
  }

  getCustomerFeedbacks(customerID) {
    return http.get(`/feedbacks?customerid=${customerID}`);
  }

  getLolFeedbacks(lolID) {
    return http.get(`/feedbacks?lolid=${lolID}`);
  }

  findByType(feedbackType) {
    return http.get(`/feedbacks?feedbacktype=${feedbackType}`);
  }

  findBySummary(feedbackSummary) {
    return http.get(`/feedbacks?feedbacksummary=${feedbackSummary}`);
  }

  findByDetail(feedbackDetail) {
    return http.get(`/feedbacks?feedbackdetail=${feedbackDetail}`);
  }

  get(feedbackID) {
    return http.get(`/feedbacks/${feedbackID}`);
  }

  create(data) {
    return http.post("/feedbacks", data);
  }

  update(feedbackID, data) {
    return http.put(`/feedbacks/${feedbackID}`, data);
  }

  delete(feedbackID) {
    return http.delete(`/feedbacks/${feedbackID}`);
  }

  deleteAll() {
    return http.delete(`/feedbacks`);
  }
}

export default new FeedbackService();